<template>
  <div>
    <el-image src="static/img/images09.png" class="el-image-head"/>
    <div class="div-content">
      <div class="div-content-title">
        <label class="label-title">人才招聘</label>
      </div>
      <div class="div-content-link">
        <el-link :underline="false" class="link" @click.native="jumpUrl()">
          https://www.zhipin.com/job_detail/?query=%E6%B7%B1%E5%9C%B3%E6%85%A7%E6%BA%90%E5%88%9B%E6%96%B0%E7%A7%91%E6%8A%80%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8
          <span class="link">&city=101280600&industry=&position=</span>
        </el-link>
      </div>
      <div class="div-content-go">
        <el-button class="el-button-go" @click.native="jumpUrl">打开链接</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignboardUs',
  methods: {
    jumpUrl () {
      window.open('https://www.zhipin.com/job_detail/?query=%E6%B7%B1%E5%9C%B3%E6%85%A7%E6%BA%90%E5%88%9B%E6%96%B0%E7%A7%91%E6%8A%80%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&city=101280600&industry=&position=')
    }
  }
}
</script>

<style scoped>
.el-image-head{
  height: 541px;
  width: 100%;
}
.label-title{
  font-size: 26px;
  color: #FFB400;
  padding-bottom: 20px;
}
.div-content{
  width: 60%;
  margin-top: 80px;
  margin-left: 20%;
  margin-right: 20%;
  min-height: 400px;
}
.link{
  font-size: 14px;
  cursor: pointer;
  text-underline: none;
}
.link:hover{
  color: dodgerblue;
}
.div-content-link{
  margin-top: 40px;
  margin-bottom:60px;
}
.div-content-go{
  text-align: center;
}
.el-button-go{
  background: #FFB400;
  color: black;
  font-size: 16px;
  border: none;
}
.el-button-go:hover{
  background: #FFB400;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/SignboardUs.vue